import React from "react";

// IMG Y IMPORTACIONES
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { Divider } from "@mui/material";

const Noticias = ({ noticia, auditoria }) => {

  return (
    <>
      {/* BODY */}
      <div id="img-noticia" className="block-img-responsive">
        <picture>
          <source
            media="(orientation: portrait) and (max-width: 1199px)"
            className="height-img-cover img-responsive"
            srcSet={
              noticia?.imageCover_tablet ? noticia?.imageCover_tablet[0]?.url : ""
            }
            alt={
              noticia?.imageCover_tablet
                ? noticia?.imageCover_tablet[0]?.alt
                : noticia?.title
            }
            title={noticia?.title}
          />
          <img
            src={noticia?.imageCover ? noticia?.imageCover[0]?.url : ""}
            className="height-img-cover img-responsive"
            alt={
              noticia?.imageCover ? noticia?.imageCover[0]?.alt : noticia?.title
            }
            title={noticia?.title}
          />
        </picture>
      </div>
      <div className="container">
        <section className="info-producto">
          <div id="tarjeta-azul">
            <div className="texto-slider mb-3">
              <p>{noticia?.category}</p>
            </div>
            <div className="title-info-noticias">
              <h3>{noticia.title} </h3>
            </div>
            <Divider id="divisor"></Divider>
            {noticia?.read_time && (
              <article className="seccion-vistas-noticias seccion-redes-card pb-2 color-white">
                <BookmarkBorderIcon id="icon-redes-noticias" />
                {noticia?.read_time} min lectura
              </article>
            )}
          </div>

          <div className="card-ventajas">
            <p dangerouslySetInnerHTML={{ __html: noticia.top }}></p>
          </div>
        </section>
        <Divider />
        <div>
          <div id="noticia-video">
            <div>
              <div className="">
                <article className="container info-card mt-3">
                  <p
                    id="body-noticia"
                    dangerouslySetInnerHTML={{ __html: noticia.body }}
                  ></p>
                </article>
              </div>
              <div
                className={`${
                  noticia?.moduloTextImage === true ? "d-flex" : ""
                } cards-noticias display-none `}
              >
                <article className="uno">
                  <picture>
                    <source
                      className="img-card-noticia"
                      srcSet={
                        noticia.imageBody ? noticia.imageBody[0]?.url : ""
                      }
                      alt={
                        noticia.imageBody
                          ? noticia.imageBody[0]?.alt
                          : noticia?.title
                      }
                      title={noticia?.title}
                    />
                    <img
                      src={noticia.imageBody ? noticia.imageBody[0]?.url : ""}
                      alt={
                        noticia.imageBody
                          ? noticia.imageBody[0]?.alt
                          : noticia?.title
                      }
                      title={noticia?.title}
                      className="img-card-noticia"
                    />
                  </picture>
                </article>
                <article className="container info-card dos">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: noticia?.footer_news,
                    }}
                  ></p>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Noticias;
